import * as Config from '../../../config';
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import './Cart.css';

import ListV2 from '../content/list/ListV2';
import Spinner from '../common/Spinner';
import ButtonCheckout from './ButtonCheckout';
import useGetOne from '../../../hooks/useGetOne';
// import ButtonEditor from '../touch/ButtonEditor';
// import ButtonsCartEdit from './ButtonsCartEdit';
import CartPlaylistInfo from './CartPlaylistInfo';

function ConnectedCartPlaylist({
  style, api, dimension, refresh = null, touchEditor
}) {
  const { item } = useGetOne(api, '/my/default-cart/', refresh);
  const { width, height } = dimension;

  const customFormatData = (data) => data.map(Config.formattedFromCart);
  const isFull = (item && item.tracks.length >= Config.MAX_CART_ITEMS);

  return (!item)
    ? <Spinner />
    : (
      <div className={`flexColumn playlist-page`} style={{ ...style }}>
        <div className={`flexRow card-container-cart`}>
          <div className={`playlist-infos infos-cart flexRow space-between`}>
            <div className={'flexColumn f-center'}>
              <p className={`playlist-title type-title`} style={{size: 24}}>Cart</p>
              <div className={`playlist-p type-small flexColumn`}>
                <div className={'flexRow'} style={{height: 16, gap: 4, color: '#8C8C8C'}}>
                  <CartPlaylistInfo />
                  <span> • <a className='link-enable' target={'blank'} href={`https://www.${Config.APP_NAME}.com/account/carts`}>Cart settings</a></span>
                </div>          
                {/* <span className={'type-placeholder'}>Tracks are added to your default cart. To change it, visit cart preferences on {Config.capAppName()}.com.</span> */}
              </div>
            </div>
            <div className={'flexColumn'}>
              {(item && item.tracks.length > 0) && (
                <div className={'flexRow space-between playlist-actions-container'}>
                  {/* {touchEditor && <ButtonsCartEdit /> } */}
                  {/* <ButtonEditor label={`Edit`} /> */}
                  { !touchEditor && <ButtonCheckout id={item.id} /> }
                </div>
              )}
            </div>
          </div>
        </div>

        {  (item && item.tracks.length > 0) ? ( 
          <div className={`content-container`} style={{ width }} >
            <ListV2
              id={'Cart'}
              pathApi={'/my/default-cart/items/?per_page=100'}
              customFormatData={customFormatData}
              sortable={false}
              width={width}
              height={ isFull ? height - 185 : height - 135 }
              size={Config.LIST_ROW_HEIGHT}
              style={{ marginTop: 0 }}
              filtersStyle={{ display: `none`, top: 0, right: 0 }}
              panelStyle={{}}
              filters={[]}
              type={`Cart`}
              enableKeys={true}
              enableShortcuts={true}
              orderBy={[]}
              isBoost={true}
              automix={false}
              isLoadMore={true}
              from={'/cart'}
            />
            {isFull 
              ? (
                <div style={{marginTop: 16}}>
                  <span className={'type-black-5'} >DJ App Cart limit is {Config.MAX_CART_ITEMS}, please remove track(s) or checkout.</span>
                </div>
              )
              : null
            }
          </div>
          ) : ((item && item.tracks.length === 0)
            ? <span className={'type-placeholder'} style={{marginTop: 120, position: 'absolute'}}>Tracks selected for purchase using add to cart will appear here, ready for checkout.</span>
            : null
        ) }
      </div>
    )
}

ConnectedCartPlaylist.propTypes = {
  refresh: PropTypes.any, 
  style: PropTypes.object
}

const CartPlaylist = connect(
  state => ({
    api: state.api,
    dimension: state.dimension,
    touchEditor: state.touchEditor
  })
)(ConnectedCartPlaylist);

export default CartPlaylist;
